export const DEFAULT_MAIN_CHAINS = [
    // mainnets
    'flow:mainnet'
]

export const DEFAULT_TEST_CHAINS = [
    // testnets
    'flow:emulator',
    'flow:testnet'
]

export const DEFAULT_CHAINS = [...DEFAULT_MAIN_CHAINS, ...DEFAULT_TEST_CHAINS]

export const DEFAULT_PROJECT_ID = process.env.REACT_APP_WC_PROJECT_ID

export const DEFAULT_APP_METADATA = {
    name: 'Flow Rider',
    description: 'A test Dapp for mobile wallet development',
    url: 'https://flow-rider.vercel.app',
    icons: ['https://flow-rider.vercel.app/images/flow_rider_icon.png']
}

/**
 * Flow
 */

export const DEFAULT_FLOW_METHODS = {
    FLOW_AUTHN: 'flow_authn',
    FLOW_AUTHZ: 'flow_authz',
    FLOW_USER_SIGN: 'flow_user_sign'
}

export const DEFAULT_FLOW_EVENTS = {}

export const DECLINE_RESPONSE = "Declined: Externally Halted"